import { unwrap, unwrapUpsert, unwrapVoid } from '../http.js';
import { paginate } from '../pagination.js';
export function createWorkoutsApi(client) {
    async function list(query) {
        return unwrap(await client.GET('/v1/workouts', { params: { query: query ?? {} } }));
    }
    return {
        async upsert(clientId, body) {
            const { value, created } = unwrapUpsert(await client.PUT('/v1/workouts/{clientId}', { params: { path: { clientId } }, body }));
            return { session: value, value, created };
        },
        list,
        iterate(query) {
            return paginate(list, query);
        },
        async get(clientId) {
            return unwrap(await client.GET('/v1/workouts/{clientId}', { params: { path: { clientId } } }));
        },
        async remove(clientId) {
            unwrapVoid(await client.DELETE('/v1/workouts/{clientId}', { params: { path: { clientId } } }));
        },
        async upsertSet(sessionClientId, setClientId, body) {
            const { value, created } = unwrapUpsert(await client.PUT('/v1/workouts/{sessionClientId}/sets/{clientId}', {
                params: { path: { sessionClientId, clientId: setClientId } },
                body,
            }));
            return { set: value, value, created };
        },
        async removeSet(sessionClientId, setClientId) {
            unwrapVoid(await client.DELETE('/v1/workouts/{sessionClientId}/sets/{clientId}', {
                params: { path: { sessionClientId, clientId: setClientId } },
            }));
        },
        async sync(body) {
            return unwrap(await client.POST('/v1/workouts/sync', { body }));
        },
    };
}
//# sourceMappingURL=workouts.js.map